import React from "react";

const AddNewUser = () => {
  return (
    <div>
      <h1>add new user</h1>
    </div>
  );
};

export default AddNewUser;
